// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCache = exports.OneShotEventCache = void 0;
class OneShotEventCache {
    constructor() {
        this.m = new Map();
    }
    set(key, cb) {
        if (!this.m.has(key)) {
            this.m.set(key, [cb]);
            return this;
        }
        this.m.get(key).push(cb);
        return this;
    }
    has(key, val) {
        const events = this.m.get(key);
        if (events === undefined || !val) {
            return !!events;
        }
        return !!events.find((other) => other === val);
    }
    delete(key, val) {
        const events = this.m.get(key);
        if (events === undefined) {
            return false;
        }
        if (!val) {
            return this.m.delete(key);
        }
        const id = events.findIndex((other) => other === val);
        if (id === -1) {
            return false;
        }
        events.splice(id, 1);
        return true;
    }
    get(key) {
        if (!this.m.has(key)) {
            return undefined;
        }
        const cbs = this.m.get(key);
        this.m.delete(key);
        return cbs;
    }
    *[Symbol.iterator]() {
        for (const [key, cbs] of this.m) {
            yield [key, cbs];
        }
    }
    clear() {
        this.m.clear();
    }
}
exports.OneShotEventCache = OneShotEventCache;
class EventCache extends OneShotEventCache {
    constructor() {
        super();
    }
    get(key) {
        return this.m.get(key);
    }
}
exports.EventCache = EventCache;
//# sourceMappingURL=event_cache.js.map